import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { BrandService } from 'brand';
import { ReplaceTokenPipe, TranslatePipe } from 'translate';
import { CurrencyFormatterPipe } from 'utils';
import { BadgeComponent } from '../../badge/badge.component';

@Component({
  selector: 'lib-product-card-price',
  imports: [CommonModule, BadgeComponent, TranslatePipe, ReplaceTokenPipe, CurrencyFormatterPipe],
  templateUrl: './product-card-price.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardPriceComponent {
  public price = input.required<number>();
  public discountedPrice = input<number>();
  public discountLabel = input<string>();
  public isOfferBox = input(false);
  public brandService = inject(BrandService);
  public isNavProduct = input(false);
  public compactMode = input(false);
}
